import { useEffect } from 'react';

import Image from '@/components/image/NextImage';
import { useGuideInfo } from '@/hooks/app/useGuideInfo';
import { formatResizedUrl } from '@/utils/app/formatResizedUrl';

import GuideActions from './GuideActions';
import GuidePersonnel from './GuidePersonnel';
import { Description, HorizontalLine, ImageWrapper, OverviewWrapper, Title, Wrapper } from './styles';
import { GuideInfoProps } from './types';

const GuideInfo = ({ program, guide }: GuideInfoProps) => {
	const { image, title } = useGuideInfo(guide, program);

	// Focus heading on screen change
	useEffect(() => {
		const heading = document.querySelector('h1');
		if (heading) {
			heading.focus();
		}
	}, []);

	return (
		<Wrapper>
			<OverviewWrapper>
				<div>
					<Title tabIndex={-1}>{title}</Title>
					<Description>{program.description}</Description>
				</div>
				<GuidePersonnel program={program} />
				<HorizontalLine />
				<GuideActions guide={guide} />
			</OverviewWrapper>
			{image && (
				<ImageWrapper>
					<Image src={formatResizedUrl(image.url, 294)} alt="" layout="fill" objectFit="cover" />
				</ImageWrapper>
			)}
		</Wrapper>
	);
};

export default GuideInfo;
